import React from "react";
import { UploadedFile } from "../types/UploadedFile.type";
import { FileItem } from "./FileItem";
import { SharedFileItemProps } from "../types/ShareProps.types";

interface FileListProps extends SharedFileItemProps {
	files: UploadedFile[];
}

export const FileList: React.FC<FileListProps> = ({
	files,
	isPreview,
	extraData,
	onRemove,
	onUploadComplete,
	onUploadStart,
	onUploadError,
}) => {
	if (!files || files.length === 0) {
		return null;
	}

	return (
		<div className="mt-3">
			{files.map((file) => (
				<FileItem
					key={file.id ?? file.uploadId}
					file={file}
					extraData={extraData}
					isPreview={isPreview}
					onRemove={onRemove}
					onUploadComplete={onUploadComplete}
					onUploadStart={onUploadStart}
					onUploadError={onUploadError}
				/>
			))}
		</div>
	);
};
